import { Component, ElementRef, ViewChild } from '@angular/core';
import { AppMenu } from './app.menu';
import { LayoutService } from '@/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { APP_VERSION } from '@/version';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [AppMenu, RouterModule],
    template: ` <div
        class="layout-sidebar"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
    >
        <div class="sidebar-header">
            <a [routerLink]="['/']" class="app-logo">
            <svg viewBox="0 0 124 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="app-logo-normal" role="img" aria-label="CenazeFon">
                    <rect x="0" y="0" width="22" height="22" rx="5" fill="var(--logo-color)" />
                    <path d="M12.6 6.2a5 5 0 1 0 0 9.6" fill="none" stroke="var(--menu-bg)" stroke-width="2.2" stroke-linecap="round" />
                    <path d="M14.6 6.6v8.8M14.6 6.6h3.4M14.6 10.8h2.8" fill="none" stroke="var(--menu-bg)" stroke-width="2" stroke-linecap="round" />
                    <text x="29" y="16.5" font-size="16" font-weight="600" fill="var(--logo-text-color, var(--logo-color))" textLength="94" lengthAdjust="spacingAndGlyphs">CenazeFon</text>
                </svg>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="app-logo-small" role="img" aria-label="CenazeFon">
                    <rect x="0" y="0" width="22" height="22" rx="5" fill="var(--logo-color)" />
                    <path d="M12.6 6.2a5 5 0 1 0 0 9.6" fill="none" stroke="var(--menu-bg)" stroke-width="2.2" stroke-linecap="round" />
                    <path d="M14.6 6.6v8.8M14.6 6.6h3.4M14.6 10.8h2.8" fill="none" stroke="var(--menu-bg)" stroke-width="2" stroke-linecap="round" />
                </svg>
            </a>
            <button
                class="layout-sidebar-anchor p-link z-2 hover:cursor-pointer"
                type="button"
                (click)="anchor()"
            ></button>
        </div>

        <div #menuContainer class="layout-menu-container">
            <app-menu></app-menu>
        </div>

        <div class="layout-sidebar-footer" [title]="'CenazeFon Admin ' + appVersion">v{{ appVersion }}</div>
    </div>`,
})
export class AppSidebar {
    timeout: any = null;
    appVersion = APP_VERSION;

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
    ) {}

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true,
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false,
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored,
        }));
    }
}
